import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#0B0B1A] py-12 px-4 relative overflow-hidden" data-id="element-66">
      <div className="absolute top-0 right-0 w-[300px] h-[200px] bg-[#00D4FF] opacity-10 blur-[100px] rounded-full pointer-events-none" data-id="element-67" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-68">
        <div className="flex justify-center mb-6" data-id="element-69">
          <ShieldCheck className="w-20 h-20 text-[#00D4FF]" data-id="element-70" />
        </div>
        <h2 className="text-3xl font-extrabold text-white mb-4 flex items-center justify-center gap-2" data-id="element-71">
          🔒 Garantía de 7 días
        </h2>
        <p className="text-2xl font-bold text-[#FF00FF] mb-4" data-id="element-72">
          Probalo sin riesgo.
        </p>
        <p className="text-lg md:text-xl text-gray-400 leading-relaxed" data-id="element-73">
          Si el material no te ayuda a entender cómo proteger tus cuentas, te
          devolvemos el 100% del dinero.
        </p>
      </div>
    </section>;
}